export default "__VITE_ASSET__SRYYARcT__"